<template>
  <fragment>
    <slot :toggle="toggle" :is-active="isActive">
      <div
        class="relative inline-block h-4 w-8 rounded-full transition-colors duration-200 ease-in-out"
        :class="{ 'bg-gray-500': !isActive, 'bg-primary': isActive }"
      >
        <slot name="trigger" :is-active="isActive" @toggle="toggle">
          <button
            class="absolute -mt-1 inline-block size-6 rounded-full bg-white shadow transition duration-200 ease-linear focus:outline-none"
            :class="{
              'left-0 -ml-2 bg-primary': !isActive,
              'translate-x-4': isActive,
            }"
            role="switch"
            @click="toggle"
          />
        </slot>
      </div>
    </slot>
  </fragment>
</template>

<script setup lang="ts">
const props = defineProps({
  value: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const emit = defineEmits(['input'])
const toggle = () => {
  isActive.value = !isActive.value
}

const isActive = computed({
  get() {
    return props.value as boolean
  },
  set(newValue: boolean): void {
    emit('input', newValue)
  },
})
</script>
